<template>
    <router-view></router-view>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: "Default",
    mounted() {
        const loading = this.$cmmLoading();
        window.console.log('default view mounted');
        this.getWebZineList()
            .then(() => {
                const currentPath = this.$router.history.current.path;
                if (currentPath === '/') {
                    this.$router.push(`publish/${this.selectedWebZineId}`);
                }
            })
            .finally(() => loading.close());
    },
    computed: {
        ...mapGetters('webzineView', [
            'webZineList',
            'mode',
            'selectedWebZineId'
        ])
    },

    methods: {
        ...mapMutations('webzineView', [
            'setSelectedWebZineId',
            'setMode'
        ]),
        ...mapActions('webzineView', [
            'getWebZineList'
        ])

    }
}
</script>

<style scoped>

</style>
